import React from 'react'

const TextareaInput = ({ id, label, name, onChange, onKeyDown, value, placeholder, className, required, error, touched, icon }) => {
    return (
        <>
            <label htmlFor={id} className={`${className} textarea textarea-sm textarea-bordered border-solid border flex items-center gap-[2px] focus:outline-none focus-within:outline-none focus-visible:outline-none `}>
                {label && <span className='flex-shrink-0 flex-grow-0 '>{label}</span>}
                <textarea id={id}
                    name={name}
                    required={required}
                    onChange={onChange}
                    onKeyDown={onKeyDown}
                    value={value}
                    className={` flex-auto w-full input-bordered border-g p-0  focus:outline-none focus-within:outline-none focus-visible:outline-none`}
                    placeholder={placeholder}
                />
                {icon && icon}

            </label>
            {error && touched && <div className='text-red-400 text-sm ml-1'>{error}</div>}
        </>

    )
}

export default TextareaInput
